var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuxiliaryList',{attrs:{"items":_vm.contactLensTestManufacturers,"typeName":"fabricante","deleteMutation":_vm.deleteItem,"saveMutation":_vm.save,"refreshList":_vm.refreshList}})}
var staticRenderFns = []

export { render, staticRenderFns }